module.exports = "<div style=\"display: block;\">\n  <span class=\"vertical_title\" style=\"display: none;\">{{title}}</span>\n  <canvas  baseChart \n    [datasets]=\"data\"\n    [title]=\"title\" \n    [labels]=\"labels\"\n    [options]=\"options\"\n    [legend]=\"barlineChartLegend\"\n    [colors]=\"lineChartColors\" \n    [chartType]=\"barChartType\">\n  </canvas>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3113546464/src/src/app/common/dynamic-vendor-po-bar-chart/dynamic-vendor-po-bar-chart.component.html
// module id = ../../../../../src/app/common/dynamic-vendor-po-bar-chart/dynamic-vendor-po-bar-chart.component.html
// module chunks = main